import {
  RESET_CREATE_ACCOUT_DATA,
  SET_USER_CREATE_ACCOUT_DATA
} from '../../constants/actions';

export function resetCreateAccountData () {
  return dispatch => dispatch({type: RESET_CREATE_ACCOUT_DATA});
}
export function setUserCreateAccountData (data) {
  return dispatch => dispatch({type: SET_USER_CREATE_ACCOUT_DATA, data});
}
// export function setUserCreateGender ()



// WEBPACK FOOTER //
// ./src/store/actions/createAccountData.js